import React, { useState } from 'react';
import moment from 'moment';

import EmptyData from '../../../components/global/emptyData';

const DiagnosisRow = ({ id, diag_date, icd10, diag_type_txt, doctor_name, institution_name, division_name }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <li
      key={id}
      className="diag-list__item"
      onClick={() => setExpanded((prev) => !prev)}
      style={{ cursor: 'pointer' }}
    >
      {/* Collapsed row */}
      <div className="diag-list__row">
        <div className="diag-list__col diag-list__col--date">
          {diag_date ? (
            <><span>{moment(diag_date).format('DD.MM')}</span><span className="diag-list__date-year">{moment(diag_date).format('YYYY')}</span></>
          ) : '—'}
        </div>
        <div className="diag-list__col diag-list__col--name">
          {icd10?.code && <span className="diag-list__inline-code">{icd10.code}</span>}
          <span className="diag-list__name-text">{icd10?.name || '—'}</span>
        </div>
        <div className="diag-list__col diag-list__col--chevron">
          <i className={`fas fa-chevron-${expanded ? 'up' : 'down'}`} />
        </div>
      </div>

      {/* Expanded details */}
      {expanded && (
        <div className="diag-list__details" onClick={(e) => e.stopPropagation()}>
          <div className="visit-card">

            <div className="visit-card__col-left">
              <div className="visit-card__hospital">
                <span className="visit-card__label">Заклад охорони здоров'я</span>
                {institution_name || '—'}
                {division_name && (
                  <div style={{ fontWeight: 400, fontSize: 13, color: '#696666', marginTop: 2 }}>
                    {division_name}
                  </div>
                )}
              </div>
            </div>

            <div className="visit-card__divider" />

            <div className="visit-card__col-right">
              <div className="visit-card__doctor">
                <div className="visit-card__doctor-icon">
                  <i className="fas fa-user-md" />
                </div>
                <div className="visit-card__doctor-body">
                  <span className="visit-card__label">Лікуючий лікар</span>
                  <div className="visit-card__doctor-name">{doctor_name || '—'}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      )}
    </li>
  );
};

const Diagnoses = ({ patient }) => {
  const diag = patient.data?.diag;

  if (!diag || !diag.length) return <EmptyData />;

  return (
    <div className="personal-visits personal-visits-wrapper">
      <div className="diag-list">
        {/* Header */}
        <div className="diag-list__item diag-list__item--header">
          <div className="diag-list__row">
            <div className="diag-list__col diag-list__col--date">Дата</div>
            <div className="diag-list__col diag-list__col--name">Діагноз</div>
            <div className="diag-list__col diag-list__col--chevron" />
          </div>
        </div>

        <ul className="personal-visits-list" style={{ marginTop: 0 }}>
          {diag.map((item) => (
            <DiagnosisRow key={item.id} {...item} />
          ))}
        </ul>
      </div>

      <style>{`
        .diag-list {
          background: #fff;
          border-radius: 10px;
          box-shadow: 0 2px 16px rgba(9,79,163,0.11);
          overflow: hidden;
          margin-top: 20px;
        }
        .diag-list__item--header .diag-list__row {
          background: #edf4f8;
          border-bottom: 1px solid #d0e5f0;
        }
        .diag-list__item--header .diag-list__col {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: #979797;
          padding: 10px 14px;
        }
        .diag-list__item {
          border-bottom: 1px solid #d0e5f0;
          transition: background 0.15s;
          list-style: none;
        }
        .diag-list__item:last-child {
          border-bottom: none;
        }
        .diag-list__item:not(.diag-list__item--header):hover {
          background: #f5f9fd;
        }
        .diag-list__row {
          display: flex;
          align-items: center;
          width: 100%;
        }
        .diag-list__col {
          padding: 13px 14px;
          font-size: 14px;
          color: #333;
          line-height: 1.4;
        }
        .diag-list__col--date {
          flex: 0 0 72px;
          font-weight: 600;
          color: #1767c8;
          white-space: nowrap;
          line-height: 1.3;
          text-align: center;
        }
        .diag-list__date-year {
          display: block;
          font-size: 11px;
          font-weight: 500;
          color: #979797;
          text-align: center;
        }
        .diag-list__type-badge {
          display: inline-block;
          font-size: 11px;
          font-weight: 500;
          color: #696666;
          background: #efeff4;
          border-radius: 4px;
          padding: 1px 6px;
          margin-top: 2px;
          white-space: nowrap;
          vertical-align: middle;
          line-height: 1.6;
        }
        .diag-list__inline-code {
          display: inline-block;
          font-size: 12px;
          font-weight: 700;
          color: #1767c8;
          background: #e8f1f7;
          border-radius: 4px;
          padding: 1px 6px;
          margin-right: 7px;
          white-space: nowrap;
          vertical-align: middle;
          line-height: 1.6;
        }
        .diag-list__col--name {
          flex: 1;
          min-width: 0;
          font-size: 15px;
          font-weight: 500;
          color: #1d1b1b;
        }
        .diag-list__name-text {
          margin-right: 7px;
        }
        .diag-list__col--chevron {
          flex: 0 0 36px;
          text-align: center;
          color: #979797;
          font-size: 12px;
        }
        .diag-list__details {
          padding: 20px;
          background: #fff;
        }

        @media (max-width: 600px) {
          .diag-list__details .visit-card__divider {
            display: none;
          }
          .diag-list__col--date {
            flex: 0 0 58px;
            font-size: 12px;
            padding: 10px 6px;
          }
          .diag-list__col--name {
            font-size: 13px;
            padding: 10px 6px;
          }
          .diag-list__col--chevron {
            flex: 0 0 28px;
            padding: 10px 4px;
          }
          .diag-list__details {
            padding: 14px;
          }
          .diag-list__item--header .diag-list__col {
            padding: 8px 6px;
          }
        }
      `}</style>
    </div>
  );
};

export default Diagnoses;

